import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import ParticipantModel from '@/models/ParticipantModel';
import PouleModel from '@/models/PouleModel';
import MatchModel from '@/models/MatchModel';
import CourtModel from '@/models/CourtModel';
import { moduleSnackbar } from './moduleSnackbar';
import { saveAs } from 'file-saver';

Vue.use(Vuex);

// Create a new instance of Database.
const database = new VuexORM.Database();

// Register Models to Database. note: you can also pass a 2nd parameter to make a vuex-module
database.register(ParticipantModel, moduleSnackbar); // add an normal vuex-module as an additional parameter... adding modules the normal way does not work
database.register(PouleModel);
database.register(MatchModel);
database.register(CourtModel);

// generate unique ids
function getUuidv4 () {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
  // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
};

// LocalStorage https://www.mikestreety.co.uk/blog/vue-js-using-localstorage-with-the-vuex-store
const store = new Vuex.Store({
  plugins: [VuexORM.install(database)],

  state: {
  },
  getters: {
  },
  mutations: {
    // requested at intitalization: check for localStorage
    INITIALIZE_STORE (state) {
      // check if ID exists
      if (localStorage.getItem('tennispoule')) {
        // replace the state
        this.replaceState(Object.assign(state, JSON.parse(localStorage.getItem('tennispoule'))));
      } else {
        // fill with dummy data
        const poules = [
          { name: 'A', order: 1 },
          { name: 'B', order: 2 },
          { name: 'C', order: 3 }
        ];
        PouleModel.insert({ data: poules });

        const participants = [
          { name: 'Lambert', info: 'info' },
          { name: 'Jan-Willem' },
          { name: 'Anouk' },
          { name: 'Esther' }
        ];

        ParticipantModel.insert({ data: participants }); // insert ADDs the data, create removes existing data

        /*
        const matchModels = [
          { winner: 'a', score: '6-7' }
        ];

        MatchModel.insert({ data: matchModels });
        */
      }
    },

    // save the current state(store) to a file
    SAVE_STORE (state) {
      // using file-saver https://github.com/eligrey/FileSaver.js //  https://www.npmjs.com/package/file-saver // https://www.websparrow.org/web/how-to-create-and-save-text-file-in-javascript
      var blob = new Blob([JSON.stringify(state)], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, 'tennispoule.json');
      console.log('saved');
      // Other source which did not work direclty // Read and write (localstorage-data) from/to file: https://stackoverflow.com/questions/42743511/reading-writing-to-a-file-in-javascript
    },

    // set the state from the file-contents
    SET_STATE (state, file) {
      this.replaceState(Object.assign(state, JSON.parse(file)));
    }
  },
  actions: {
  },
  modules: {
  }
});

// is triggered for every mutation
store.subscribe((mutation, state) => {
  console.log('subscribe mutation', mutation);
  localStorage.setItem('tennispoule', JSON.stringify(state));
});

export default store;
